module.exports = __webpack_public_path__ + "static/img/loading.26ef8bb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/loading.gif
// module id = nD4N
// module chunks = 1